const truncateUrl = (url: string, maxLength = 40): string => {
  if (url.length <= maxLength) return url;

  return url.substring(0, maxLength - 3) + '...';
};

/**
 * Creates a display-friendly version of the manifest JSON with truncated URLs.
 * This version should only be used for UI display, not for submission.
 */
export const buildDisplayManifestJson = (
  manifestJson: string | undefined,
): string | null => {
  if (!manifestJson) return null;

  try {
    const manifest = JSON.parse(manifestJson);

    if (manifest.redirect_url) {
      manifest.redirect_url = truncateUrl(manifest.redirect_url);
    }

    if (manifest.setup_url) {
      manifest.setup_url = truncateUrl(manifest.setup_url);
    }

    if (manifest.hook_attributes?.url) {
      manifest.hook_attributes.url = truncateUrl(manifest.hook_attributes.url);
    }

    return JSON.stringify(manifest, null, 2);
  } catch (error) {
    console.error('Failed to parse manifest for display:', error);

    return manifestJson;
  }
};
